import { CircularProgress } from "@mui/material";
import React from "react";
import { useUTLSettingsContext } from "./UTLSettingContext";
import { useUserContext } from "./userContext";

export const ProvidersLoader = ({
	children,
}: {
	children: React.ReactNode;
}) => {
	const { isLoading: isUsersLoading } = useUserContext();
	const { isLoading: isSettingsLoading } = useUTLSettingsContext();

	if (isUsersLoading || isSettingsLoading) {
		return (
			<div
				style={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					height: "80vh",
				}}
			>
				<CircularProgress />
			</div>
		);
	}

	return <>{children}</>;
};
